import { SitePadding } from './../../Components/Global/SiteWide/SiteWide.styles';
import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled, { css } from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('bgColor', brand.greyVeryLight)};
  ${setCssVar('fgColor', brand.black)};

  .theme-hh & {
    ${setCssVar('bgColor', brand.hortHouse.greenDark)};
    ${setCssVar('fgColor', brand.white)};
  }

  .theme-apl & {
    ${setCssVar('bgColor', brand.greyVeryLight)};
    ${setCssVar('fgColor', brand.black)};
  }

  display: flex;

`;
const Inner = styled.div `
  position: relative;
  overflow: hidden;
  height: 100%;
  justify-content: center;
  
  border-radius: 11px;
  padding: 32px ${SitePadding}px;

  display: grid;
  gap: 10px;
  grid-template-columns: repeat(13, 1fr);

  @media ${from(Device.Tablet)} {
    gap: 30px;
    border-radius: 24px;
  }

  ${({ hasBackground }) => hasBackground &&
    css `
      background-color: ${cssVar('bgColor')};
    `}

`;
const ContentWrapper = styled.div `
  margin: 0 0 32px 0;
  position: relative;

  @media ${until(Device.Tablet)} {
    grid-column: 1 / span 13;
  }

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 2 / span 5;
  }

  [data-image-position='left'] & {
    @media ${until(Device.Tablet)} {
      grid-row: 2;
    }

    @media ${from(Device.Tablet)} {
      grid-column: 8 / span 6;
      grid-row: 1;
    }
    @media ${from(Device.Desktop)} {
      grid-column: 8 / span 5;
    }
  }
`;
const Title = styled.h2 `
  ${fonts.sourceSansPro.regular};
  color: ${cssVar('fgColor')};
  margin-bottom: 30px;
  font-size: 30px;
  line-height: 38px;

  @media ${from(Device.TabletLarge)} {
    font-size: 35px;
    line-height: 43px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 40px;
    line-height: 48px;
  }

  @media ${until(Device.Tablet)} {
    font-size: 25px;
    line-height: 35px;
  }
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles}
`;
const ImageWrapper = styled.div `
  position: relative;
  align-self: center;
  height: 0;
  padding-bottom: ${(425 / 665) * 100}%;

  @media ${until(Device.Tablet)} {
    grid-column: 1 / span 13;
  }

  @media ${from(Device.Tablet)} {
    grid-column: 8 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 8 / span 5;
  }

  [data-image-position='left'] & {
    @media ${until(Device.Tablet)} {
      grid-row: 1;
    }
    @media ${from(Device.Tablet)} {
      grid-column: 1 / span 6;
    }
    @media ${from(Device.Desktop)}
    {
      grid-column: 2 / span 5;
    }
  }
`;
const Image = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  object-position: center center;
  width: 100%;

  [data-image-mode='contain'] & {
    object-fit: contain;
  }

  [data-image-mode='cover'] & {
    border-radius: 11px;
    object-fit: cover;

    @media ${from(Device.Tablet)} {
      border-radius: 24px;
    }
  }
`;
const CtaHolder = styled.div `
  margin-top: 30px;
`;
export default {
    Content,
    Container,
    ContentWrapper,
    CtaHolder,
    Image,
    ImageWrapper,
    Inner,
    Title,
};
